function minusTime(startTime, endTime) {
  return new Date(endTime) - new Date(startTime)
}

export { minusTime }
